import { Box } from '@mui/material';
import ExoForm from './ExoForm';
import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../api/api';
import { useState } from 'react';
import { is } from 'immutable';

export const ExoSmartParticipants = ({ onClose, onSelect }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: t('Purchasing profile'),
      key: 'properties',
      type: 'salesOjectProperties',
    },
  ];

  function requestParticipants(data) {
    DBRequest({
      config,
      path: 'leads-by-property',
      method: API_POST(data),
      onResponse: (res) => {
        onSelect(res.data);
        onClose();
      },
      onLoading: setIsLoading,
    });
  }

  return (
    <Box className="flex flex-col gap-2 pt-2">
      <ExoForm
        fields={fields}
        header={t('smart participant')}
        submitText={t('start search')}
        onSubmit={requestParticipants}
        onCancel={onClose}
        isLoading={isLoading}
      />
    </Box>
  );
};
